
// src/components/Navbar.jsx
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import "../styles/navbar.css";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* ===== ANNOUNCEMENT BAR ===== */}
      <div className="announcement-bar">
        <a
          href="https://news.subharti.org/career-counseling-session-on-transform-your-career/"
          target="_blank"
          rel="noopener noreferrer"
        >
          🎓 Career Counseling Session – Transform Your Career | Click Here
        </a>
      </div>

      {/* ===== TOP CONTACT BAR ===== */}
      <div className="top-bar">
        <div className="top-bar-inner">
          <a href="tel:9650004929" className="top-link">
            📞 9650004929
          </a>
          <a href="mailto:info@concertedpath.com" className="top-link">
            ✉️ info@concertedpath.com
          </a>
        </div>
      </div>

      {/* ===== MAIN NAVBAR ===== */}
      <header className={`site-header ${scrolled ? "scrolled" : ""}`}>
        <div className="header-inner">

          {/* BRAND */}
          <Link to="/" className="brand-link">
            <div className="brand">
              <div className="logo-wrap">
                <img
                  src="/images/concertedlogo.png"
                  alt="Concerted Path Logo"
                  className="brand-logo"
                />
              </div>

              <div className="brand-text">
                <div className="brand-title">Concerted Path</div>
                <div className="brand-sub">PATH TO SUCCESS</div>
              </div>
            </div>
          </Link>

          {/* DESKTOP NAV */}
          <nav className="main-nav">
            <NavLink to="/" className="nav-link">Home</NavLink>
            <NavLink to="/about" className="nav-link">About</NavLink>
            <NavLink to="/courses" className="nav-link">Courses</NavLink>
            <NavLink to="/fees" className="nav-link">Fees</NavLink>
            <NavLink to="/register" className="nav-link">Register</NavLink>
          </nav>

          {/* RIGHT SIDE */}
          <div className="nav-ctas">
            <NavLink to="/candidate" className="nav-link">
              Candidate Login
            </NavLink>
            <Link to="/admin" className="admin-btn">
              Admin Login
            </Link>
          </div>

          {/* HAMBURGER */}
          <button
            className={`hamburger ${open ? "open" : ""}`}
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            <span className="bar" />
          </button>
        </div>

        {/* MOBILE MENU */}
        <div className={`mobile-nav ${open ? "show" : ""}`}>
          <NavLink to="/" onClick={() => setOpen(false)}>Home</NavLink>
          <NavLink to="/about" onClick={() => setOpen(false)}>About</NavLink>
          <NavLink to="/courses" onClick={() => setOpen(false)}>Courses</NavLink>
          <NavLink to="/fees" onClick={() => setOpen(false)}>Fees</NavLink>
          <NavLink to="/register" onClick={() => setOpen(false)}>Register</NavLink>
          <NavLink to="/candidate" onClick={() => setOpen(false)}>Candidate Login</NavLink>
          <NavLink to="/admin" onClick={() => setOpen(false)}>Admin Login</NavLink>
        </div>
      </header>
    </>
  );
}